export enum ResultOptions {
  PASSED = 'passed',
  FAILED = 'failed',
  BLOCKED = 'blocked',
}
